import { Shimmer, Stack } from '@fluentui/react';
import React from 'react';

/** Placeholder rows while room list data is loading (sidebar). */
const RoomListSkeleton: React.FC<{ rows?: number }> = ({ rows = 6 }) => (
    <Stack tokens={{ childrenGap: 10 }} style={{ width: '100%', paddingTop: 12, paddingBottom: 12 }} aria-busy aria-label="Loading rooms">
        {Array.from({ length: rows }).map((_, i) => (
            <Shimmer key={i} width="92%" />
        ))}
    </Stack>
);

export default RoomListSkeleton;
